/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { HotelBooking } from '@app/hotels/hotel-bookings/hotel-booking.model';
import { HotelBookingsFormComponent } from '@app/hotels/hotel-bookings/hotel-bookings-form/hotel-bookings-form.component';
import { Night } from '@app/hotels/rooms/night.model';
import { SaleFinal } from '@app/sales/sales/sale-final.model';
import { HotelBookingsPreviewRoomsComponent } from './hotel-bookings-preview-rooms/hotel-bookings-preview-rooms.component';

@Injectable({
  providedIn: 'root',
})
export class HotelBookingsFormService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open hotel form
   * @param hotelBooking HotelBooking
   * @param showOnlyAllotmentId showOnlyAllotmentId
   * @param showOnlyNights showOnlyNights
   * @param hideBackdrop Whether or not to hide the modal's backdrop
   * @param final SaleFinal
   */
  public open(
    hotelBooking: null | HotelBooking = null,
    showOnlyAllotmentId: string = null,
    showOnlyNights: Array<Night> = null,
    hideBackdrop: boolean = false,
    final: SaleFinal = null
  ): Promise<any> {
    const config: NgbModalOptions = {
      size: 'xl' as 'lg',
      windowClass: 'modal-custom',
    };
    if (hideBackdrop) {
      config.backdropClass = 'transparent';
    }
    const modal = this.modalService.open(HotelBookingsFormComponent, config);
    modal.componentInstance.hotelBooking = hotelBooking;
    modal.componentInstance.showOnlyAllotmentId = showOnlyAllotmentId;
    modal.componentInstance.showOnlyNights = showOnlyNights;
    modal.componentInstance.final = final;
    return modal.result;
  }

  /**
   * Open preview rooming list
   * @param hotelBookingId HotelBooking ID
   */
  public previewRooms(hotelBookingId: number): Promise<any> {
    const config: NgbModalOptions = {
      size: 'fullscreen',
      windowClass: 'modal-custom',
      backdropClass: 'transparent'
    };

    const modal = this.modalService.open(HotelBookingsPreviewRoomsComponent, config);
    modal.componentInstance.hotelBookingId = hotelBookingId;
    return modal.result;
  }
}
